module.exports = __webpack_public_path__ + "static/media/pholidoptera_aptera_007_APA.a62452ef.png";